import { render } from "./Result.vue?vue&type=template&id=2c88650a"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=2c88650a&lang=css"
script.render = render

export default script